const mFeedAssetsContentModalProductoActivo = {
  mFeedAssetsContentModalProductoActivo: {
    buttonPrimary: 'ENTENDIDO',
    messageAlert: 'El curso no puede ser eliminado ya que está inluido en uno o más productos.',
    title: 'ACCIÓN DESHABILITADA'
  }
}
export default mFeedAssetsContentModalProductoActivo
